
import { computed, defineComponent, inject, PropType } from "vue";
import FollowBtn from "~/components/Articles/FollowBtn.vue";
import UserAccountModel from "~/models/UserAccountModel";

type Props = {
  userAccount: UserAccountModel
}

export default defineComponent({
  name: "UserSnsButtons",
  components: {
    FollowBtn
  },
  props: {
    userAccount: {
      type: Object as PropType<UserAccountModel>,
      required: true
    },
    mediumId: {
      type: Number,
      default: 0
    }
  },
  setup(props: Props) {
    // UserCorporatePageで設定される値を取得する
    const facebookAppKey = inject("facebookAppKey");
    const facebookId = inject("facebookId");
    const hasSns = computed(() => {
      return props.userAccount.facebook || props.userAccount.twitter || props.userAccount.noteUrl;
    });

    return {
      hasSns,
      facebookAppKey,
      facebookId
    };
  }
});
